import { useState } from 'react'
import { Button } from 'react-bootstrap'
import { fetchApi } from '@inmagik/react-crud'
import { Field, Formik, getIn } from 'formik'
import * as yup from 'yup'
import { Link, useParams } from 'react-router-dom'
import { API_URL } from '../constants'

const schema = yup.object().shape({
  password: yup
    .string()
    .required('Password è un campo obbligatorio')
    .min(8, 'La password deve essere lunga almeno 8 caratteri.'),
  repeatPassword: yup
    .string()
    .required('Conferma Password è un campo obbligatorio')
    .oneOf([yup.ref('password'), ''], 'Le password non corrispondono.'),
})

const initialValues = {
  password: '',
  repeatPassword: '',
}

export function ResetPassword() {
  const [confirm, setConfirm] = useState(false)
  const { token } = useParams()
  return (
    <div className="d-flex h-100 bg-primary">
      <div className="w-50 bg-primary h-100 d-flex flex-column justify-content-center align-items-center">
        <img
          src="/statik/main/LOGO.svg"
          height={40}
          alt=""
          className="d-block mb-2 me-2"
          onError={(e) => {
            ;(e.target as HTMLImageElement).style.display = 'none'
          }}
        />
      </div>
      <div
        className="w-50 d-flex flex-column justify-content-center align-items-center bg-white"
        style={{
          borderRadius: '20px 0 0 20px',
        }}
      >
        <div className="w-50">
          <h1 className="heading-h1">RESET PASSWORD</h1>
          <div className="p-medium">Inserisci la tua nuova password.</div>
          <Formik
            validationSchema={schema}
            initialValues={initialValues}
            enableReinitialize
            onSubmit={async (values) => {
              await fetchApi(API_URL + '/utenti/users/reset_password/', {
                method: 'POST',
                body: JSON.stringify({
                  ...values,
                  token,
                }),

                headers: {
                  'Content-Type': 'application/json',
                },
              }).then((e) => {
                setConfirm(true)
              })
            }}
          >
            {({ handleSubmit, touched, errors }) => (
              <form onSubmit={handleSubmit}>
                {!confirm && (
                  <div className="mt-2">
                    <div className="form-group">
                      <label
                        htmlFor="password"
                        className="label-m text-body-secondary"
                      >
                        Password
                      </label>
                      <Field
                        name="password"
                        type="password"
                        className={
                          'form-control' +
                          (getIn(errors, 'password') &&
                          getIn(touched, 'password')
                            ? ' is-invalid'
                            : '')
                        }
                      />
                      {getIn(errors, 'password') &&
                        getIn(touched, 'password') && (
                          <div className="text-danger">
                            {getIn(errors, 'password')}
                          </div>
                        )}
                    </div>
                    <div className="form-group mt-2">
                      <label
                        htmlFor="repeatPassword"
                        className="label-m text-body-secondary"
                      >
                        Conferma Password
                      </label>
                      <Field
                        name="repeatPassword"
                        type="password"
                        className={
                          'form-control' +
                          (getIn(errors, 'repeatPassword') &&
                          getIn(touched, 'repeatPassword')
                            ? ' is-invalid'
                            : '')
                        }
                      />
                      {getIn(errors, 'repeatPassword') &&
                        getIn(touched, 'repeatPassword') && (
                          <div className="text-danger">
                            {getIn(errors, 'repeatPassword')}
                          </div>
                        )}
                    </div>
                  </div>
                )}
                <div>
                  {confirm && (
                    <div className="alert alert-success mt-2 py-1">
                      Password modificata con successo.
                    </div>
                  )}
                </div>
                {confirm ? (
                  <Button
                    variant="secondary"
                    className="w-100 mt-2 text-white"
                    onClick={() => {
                      window.location.href = '/login'
                    }}
                  >
                    Vai al login
                  </Button>
                ) : (
                  <Button
                    type="submit"
                    variant="secondary"
                    className="w-100 mt-2 text-white"
                  >
                    Reset Password
                  </Button>
                )}
              </form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  )
}
